import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 px-6 border-t" style={{
      backgroundColor: 'var(--bg-surface)',
      borderColor: 'var(--border-subtle)'
    }} data-id="element-153">
        <div className="max-w-[680px] mx-auto flex justify-center items-center gap-6" data-id="element-154">
          <button onClick={() => setActiveModal('privacy')} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors cursor-pointer" data-id="element-155">
            Política de Privacidad
          </button>
          <span className="text-[var(--bg-elevated)]" data-id="element-156">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors cursor-pointer" data-id="element-157">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-center text-xs text-[var(--text-muted)] opacity-50 mt-4" data-id="element-158">
          © {new Date().getFullYear()} ¿Por Qué a Mí, Dios? — Elegido en el
          Dolor. Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-159">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-160">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} onClick={e => e.stopPropagation()} className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-sm w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-xl" data-id="element-161">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--border-subtle)]" data-id="element-162">
                <h3 className="text-lg font-serif text-[var(--text-heading)]" data-id="element-163">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors p-1" aria-label="Cerrar" data-id="element-164">
                  <X className="w-5 h-5" data-id="element-165" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-[var(--text-primary)] text-sm leading-relaxed space-y-4" data-id="element-166">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-167" /> : <TermsContent data-id="element-168" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest mb-4" data-id="element-169">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-170">
        1. Información que recopilamos
      </h4>
      <p data-id="element-171">
        Al adquirir "¿Por Qué a Mí, Dios? — Elegido en el Dolor", recopilamos
        únicamente la información necesaria para procesar tu compra: dirección
        de correo electrónico y datos de pago. No almacenamos datos de tarjetas
        de crédito directamente; estos son procesados de forma segura por
        nuestro proveedor de pagos.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-172">
        2. Uso de la información
      </h4>
      <p data-id="element-173">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1 text-[var(--text-muted)]" data-id="element-174">
        <li data-id="element-175">Entregar el producto digital (manual) a tu correo electrónico</li>
        <li data-id="element-176">Enviar confirmación de compra</li>
        <li data-id="element-177">Brindarte soporte si lo necesitas</li>
      </ul>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-178">
        3. Compartir información
      </h4>
      <p data-id="element-179">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, excepto los proveedores de servicios necesarios para procesar
        tu compra y entrega del producto.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-180">
        4. Cookies
      </h4>
      <p data-id="element-181">
        Este sitio puede utilizar cookies esenciales para el funcionamiento
        básico de la página. No utilizamos cookies de seguimiento publicitario.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-182">
        5. Seguridad
      </h4>
      <p data-id="element-183">
        Implementamos medidas de seguridad razonables para proteger tu
        información personal. Sin embargo, ninguna transmisión por Internet es
        100% segura.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-184">
        6. Tus derechos
      </h4>
      <p data-id="element-185">
        Puedes solicitar la eliminación de tus datos personales en cualquier
        momento. Para ejercer este derecho, contáctanos y procesaremos tu
        solicitud en un plazo razonable.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest mb-4" data-id="element-186">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-187">
        1. Producto
      </h4>
      <p data-id="element-188">
        "¿Por Qué a Mí, Dios? — Elegido en el Dolor: El Manual de 21 Días" es un
        producto digital en formato descargable. Al completar la compra,
        recibirás acceso inmediato al archivo descargable.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-189">
        2. Uso personal
      </h4>
      <p data-id="element-190">
        El contenido del manual es para uso personal y privado. No está
        permitido redistribuir, copiar, revender o compartir el material sin
        autorización expresa por escrito.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-191">
        3. Naturaleza del contenido
      </h4>
      <p data-id="element-192">
        Este producto es de carácter espiritual, educativo e informativo. No
        constituye consejo médico, psicológico ni terapéutico. Si experimentas
        crisis emocionales severas u otras condiciones de salud, te animamos a
        buscar ayuda profesional.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-193">
        4. Resultados
      </h4>
      <p data-id="element-194">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos, ya que dependen de factores individuales y de la
        aplicación consistente del Plan de 21 Días.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-195">
        5. Política de reembolso
      </h4>
      <p data-id="element-196">
        Ofrecemos una garantía de 7 días. Si después de los primeros 7 días de
        lectura no sientes que este material fue escrito para ti, contáctanos y
        te devolvemos cada centavo. Sin formularios complicados. Sin preguntas.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-197">
        6. Propiedad intelectual
      </h4>
      <p data-id="element-198">
        Todo el contenido de "¿Por Qué a Mí, Dios?", incluyendo textos, diseño y
        metodología, está protegido por derechos de autor. El uso no autorizado
        puede resultar en acciones legales.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-199">
        7. Modificaciones
      </h4>
      <p data-id="element-200">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos al momento de su publicación en
        esta página.
      </p>
    </>;
}